module.exports = __webpack_public_path__ + "img/warp.87bfd20b.png";